import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../Reports.scss";

import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";

import { PrimeIcons } from "primereact/api";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import {
  getVendors,
  getVendorStatementReport,
} from "../../../store/AsyncMethods/VendorMethod";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const VendorSalesReportsTable = ({ values }) => {
  const { user } = useSelector((state) => state.AuthReducer);
  // const values = location.state.values;
  const dt = useRef(null);
  const { allVendorStatementReports } = useSelector(
    (state) => state.VendorReducer
  );
  const vendorIdsArray = values.vendor_id.map((item) => item.id);
  const updatedStatementReports = allVendorStatementReports.map(
    (item, index) => {
      return { ...item, number: index + 1 };
    }
  );
  const { enableCurrency } = useSelector((state) => state.CurrencyReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handlePrint = useReactToPrint({
    content: () => document.getElementById("sales-report-result"),
    // onBeforePrint: () => {
    //   window.close();
    // },
    onAfterPrint: () => {
      navigate("/manage-sales-report");
    },
    // onBeforePrint: () => navigate(-1),
  });

  // const { specificSale } = useSelector((state) => state.SalesReducer);
  const { allCustomers } = useSelector((state) => state.CustomersReducer);
  const totalPurchaseBody = (rowData) => {
    return `${enableCurrency?.unit || ""} ${
      enableCurrency
        ? (enableCurrency?.calculate_method === "*"
            ? rowData.total_purchase * enableCurrency?.rates
            : rowData.total_purchase / enableCurrency?.rates
          ).toLocaleString("en-IN")
        : rowData?.total_purchase?.toLocaleString("en-IN")
    }`;
  };

  const totalSalesBody = (rowData) => {
    return `${enableCurrency?.unit || ""} ${
      enableCurrency
        ? (enableCurrency?.calculate_method === "*"
            ? rowData.total_sales * enableCurrency?.rates
            : rowData.total_sales / enableCurrency?.rates
          ).toLocaleString("en-IN")
        : rowData?.total_sales?.toLocaleString("en-IN")
    }`;
  };

  const totalDiscountBody = (rowData) => {
    console.log("rowData ----->", rowData);
    return `${enableCurrency?.unit || ""} ${
      enableCurrency
        ? (enableCurrency?.calculate_method === "*"
            ? rowData.discount * enableCurrency?.rates
            : rowData.discount / enableCurrency?.rates
          ).toLocaleString("en-IN")
        : rowData?.discount?.toLocaleString("en-IN")
    }`;
  };

  const totalQuantityBody = (rowData) => {
    return rowData?.quantity;
  };

  // const totalQuantityBody = (rowData) => {
  //   return rowData?.quantity
  // };

  const totalVATBody = (rowData) => {
    return `${enableCurrency?.unit || ""} ${
      enableCurrency
        ? (enableCurrency?.calculate_method === "*"
            ? rowData.vat_amount * enableCurrency?.rates
            : rowData.vat_amount / enableCurrency?.rates
          ).toLocaleString("en-IN")
        : rowData?.vat_amount?.toLocaleString("en-IN")
    }`;
  };

  const totalAmountBody = (rowData) => {
    return `${enableCurrency?.unit || ""} ${
      enableCurrency
        ? (enableCurrency?.calculate_method === "*"
            ? rowData.amount * enableCurrency?.rates
            : rowData.amount / enableCurrency?.rates
          ).toLocaleString("en-IN")
        : rowData?.amount?.toLocaleString("en-IN")
    }`;
  };
  // const handleExport = () => {
  //   console.log("dt.curremt",dt.current)
  //   dt.current.exportCSV();
  // };
  function arrayToCsv(arr) {
    const headers = Object.keys(arr[0]).slice(0, 9);
    const csvRows = [];

    arr.forEach((obj) => {
      const row = [];
      headers.forEach((header) => {
        row.push(obj[header]);
      });
      csvRows.push(row.join(","));
    });

    return `${headers.join(",")}\n${csvRows.join("\n")}`;
  }
  function handleExport(arr) {
    const csvString = arrayToCsv(arr);
    const blob = new Blob([csvString], { type: "text/csv; charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "sales_report.csv";
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 0);
  }

  useEffect(() => {
    dispatch(getVendors());
  }, []);
  useEffect(() => {
    dispatch(
      getVendorStatementReport({
        id: vendorIdsArray,
        start_date: values.from_date,
        end_date: values.to_date,
      })
    );
  }, [values]);
  const css = `
  .my-data-table-col {
      background-color: black !important;
      color: white !important;
  }
`;

  const downloadPDF = (reportTitle, updatedStatementReports, vendorName) => {
    const doc = new jsPDF({ orientation: "portrait", format: "a4" });

    console.log("updatedStatementReports", updatedStatementReports);
    console.log(typeof updatedStatementReports);

    // Default title if none is provided
    const title = reportTitle || "Statement Report";
    const vendor = vendorName || "Vendor Name"; // Default if not provided
    const date = new Date().toLocaleDateString(); // Current date in readable format

    // Get page width
    const pageWidth = doc.internal.pageSize.getWidth();

    // Title width for centering
    const textWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const centerX = (pageWidth - textWidth) / 2;

    // **Add Vendor Name (Left)**
    doc.setFontSize(8);
    doc.text(`Vendor: ${vendor}`, 5, 10);

    // **Add Title (Centered)**
    doc.text(title, centerX, 10);

    // **Add Date (Right)**
    doc.text(`Date: ${date}`, pageWidth - 40, 10);

    // Table headers
    const headers = [
      [
        "No.",
        "Type",
        "Date",
        "Qty",
        "Unit",
        "Disc",
        "Debit",
        "Credit",
        "Balance",
      ],
    ];

    // Ensure updatedStatementReports is an array
    const data = Array.isArray(updatedStatementReports)
      ? updatedStatementReports.map((item, index) => [
          index + 1,
          item.invoice_type || "-",
          item.transaction_date || "-",
          item.quantity !== null && item.quantity !== undefined
            ? item.quantity
            : "-",
          item.unitPrice !== null && item.unitPrice !== undefined
            ? item.unitPrice.toFixed(2)
            : "-",
          item.discount !== null && item.discount !== undefined
            ? item.discount
            : "-",
          item.debit !== null && item.debit !== undefined ? item.debit : "-",
          item.credit !== null && item.credit !== undefined ? item.credit : "-",
          item.balance !== null && item.balance !== undefined
            ? item.balance
            : "-",
        ])
      : [];

    // **Minimized margins while centering the table**
    autoTable(doc, {
      startY: 15, // Move up
      head: headers,
      body: data,
      styles: { fontSize: 6, cellPadding: 0.5 }, // Smaller font & padding
      headStyles: {
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        fontSize: 7,
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      theme: "grid",
      columnStyles: {
        0: { cellWidth: 13 }, // No.
        1: { cellWidth: 30 }, // Type
        2: { cellWidth: 22 }, // Date
        3: { cellWidth: 22 }, // Qty
        4: { cellWidth: 18 }, // Unit
        5: { cellWidth: 22 }, // Disc
        6: { cellWidth: 22 }, // Debit
        7: { cellWidth: 22 }, // Credit
        8: { cellWidth: 28 }, // Balance
      },
      margin: { top: 15, bottom: 10, left: 5, right: 5 }, // **Minimized side margins**
      tableWidth: "wrap", // **Ensures the table is centered**
      horizontalPageBreak: true,
      pageBreak: "auto",
    });

    // Save PDF
    doc.save(`${title.replace(/\s+/g, "_").toLowerCase()}.pdf`);
  };

  return (
    <div id="sales-report-result" className=" mx-11 mt-4">
      <div className="flex justify-between  mb-4">
        <div className="flex space-x-4">
          <div className=" h-full flex flex-col font-weight-800 overflow-auto max-w-xs whitespace-pre break-words">
            <span className=" font-bold p-font-style text-gray-500 ">
              Vendor Name
            </span>
            <span>
              {updatedStatementReports[0]?.vendor_name
                ? updatedStatementReports[0]?.vendor_name
                : ""}
            </span>
          </div>
        </div>
        <div>
          <h1 className="text-4xl font-bold p-font-style text-center  mb-4">
            {/* {t("customer_statement_report")} */}
            Sadaat Poultry Services
          </h1>
          {/* <div className="w-full mt-1 scale-75 leading-tight text-lg">
            <div className="text-center font-bold p-font-style">
              Near Khawajgan Trust, Khawajgan Road, Gujrat
            </div>
            <div className="text-center font-bold p-font-style">
              help@reyssolutions.com | 0322-5991588
            </div>
          </div> */}
        </div>
        <div className="flex h-full items-center justify-end gap-8  space-x-4 ">
          <div>
            <span className="text-gray-500 font-medium">FROM:</span>
            <span>{values.from_date}</span>
          </div>
          <div>
            <span className="text-gray-500 font-medium">TO:</span>
            <span>{values.to_date}</span>
          </div>
        </div>
      </div>
      <div className="flex justify-end  mb-7">
        <Button
          icon="pi pi-envelope"
          severity="secondary"
          iconPos="left"
          label={t("email")}
          className="p-sales-report-btn  p-button-black p-button-rounded"
        />
        <Button
          icon="pi pi-file-excel"
          severity="secondary"
          iconPos="left"
          label="Excel"
          onClick={() => handleExport(updatedStatementReports)}
          className="p-sales-report-btn  p-button-black p-button-rounded "
        />
        <Button
          icon="pi pi-file-pdf"
          severity="secondary"
          onClick={() =>
            downloadPDF(
              "Vendor Statement Report",
              updatedStatementReports,
              updatedStatementReports[0]?.vendor_name
            )
          }
          iconPos="left"
          label="PDF"
          className="p-sales-report-btn  p-button-black p-button-rounded "
        />
        <Button
          clas=" bg-black"
          icon="pi pi-print"
          iconPos="left"
          onClick={handlePrint}
          severity="secondary"
          label="Print"
          className=" p-sales-report-btn  p-button-black p-button-rounded "
        />
      </div>
      <div className="card  shadow-sm mt-16">
        <div
          style={{ height: "400px", overflow: "auto", position: "relative" }}
        >
          <DataTable
            id="sales-report-table"
            ref={dt}
            value={updatedStatementReports}
            scrollable
            scrollHeight="flex"
            style={{ minWidth: "50rem" }}
          >
            <Column
              headerClassName="my-data-table-col sticky-header"
              field="id"
              header={<p>No.</p>}
              body={(rowData) => rowData.number}
            ></Column>
            <Column
              headerClassName="my-data-table-col sticky-header"
              field="id"
              header={<p>Invoice Type</p>}
              body={(rowData) => rowData.invoice_type}
            ></Column>
            <Column
              headerClassName="my-data-table-col sticky-header"
              body={(row) => moment(row.transaction_date).format("YYYY-MM-DD")}
              header={() => (
                <div className=" ">
                  {/* <p className=" fixed -mt-12 text-slate-950">Total</p> */}
                  <p>Transaction Date</p>
                </div>
              )}
            ></Column>
            {/* <Column
            headerClassName=" my-data-table-col"
            field="name"
            header="Customer ID"
            body={(rowData) => rowData.customer_id}
          ></Column> */}
            {/* <Column
            headerClassName="my-data-table-col sticky-header"
            field="name"
            header="Vendor Name"
            body={(rowData) => rowData.vendor_name}
          ></Column> */}
            <Column
              headerClassName="my-data-table-col sticky-header"
              field="quantity"
              header={() => (
                <div className=" ">
                  <p>Quantity</p>
                </div>
              )}
              body={(rowData) => rowData.quantity}
            ></Column>
            <Column
              headerClassName="my-data-table-col sticky-header"
              field="unit_price"
              header={() => (
                <div>
                  <p>Unit Price</p>
                </div>
              )}
              body={(rowData) => {
                const unitPrice = rowData?.unit_price;

                if (unitPrice === "-") {
                  return "-"; // If the value is exactly "-", show it as is
                }

                if (
                  unitPrice === undefined ||
                  unitPrice === null ||
                  unitPrice === ""
                ) {
                  return "0.00"; // Default value for missing or empty data
                }

                const numericValue = parseFloat(unitPrice);
                if (isNaN(numericValue)) {
                  return "0.00"; // If it's not a valid number, return default
                }

                return numericValue.toFixed(2); // Format valid numbers to 2 decimal places
              }}
            />

            <Column
              headerClassName="my-data-table-col sticky-header"
              field="discount"
              header={() => (
                <div className=" ">
                  <p>Discount</p>
                </div>
              )}
              body={totalDiscountBody}
            ></Column>
            {/* <Column
            headerClassName=" my-data-table-col"
            field="total_sales"
            header={() => (
              <div className=" ">
                <p className=" fixed -mt-12 text-slate-950">
                  {allCustomerStatementReports?.reduce(
                    (acc, cur) => acc + cur.total_sales,
                    0,
                  )}
                </p>
                <p>Sub Total </p>
              </div>
            )}
            body={totalSalesBody}
          ></Column> */}
            {/* <Column
            headerClassName=" my-data-table-col"
            field="vat_amount"
            header={() => (
              <div className=" ">
                <p className=" fixed -mt-12 text-slate-950">
                  {allCustomerStatementReports?.reduce((acc, cur) => acc + cur.vat_amount, 0)}
                </p>
                <p>VAT </p>
              </div>
            )}
            body={totalVATBody}
          ></Column> */}
            {/* <Column
            headerClassName=" my-data-table-col"
            field="total_amount"
            header={() => (
              <div className=" ">
                <p className=" fixed -mt-12 text-slate-950">
                  {allCustomerStatementReports?.reduce(
                    (acc, cur) => acc + cur.total_amount,
                    0,
                  )}
                </p>
                <p>Net Amount </p>
              </div>
            )}
            body={totalAmountBody}
          ></Column> */}

            <Column
              headerClassName="my-data-table-col sticky-header"
              field="debit"
              header={() => (
                <div className="">
                  <p>Debit</p>
                </div>
              )}
              body={(rowData) => rowData.debit}
            ></Column>
            <Column
              headerClassName="my-data-table-col sticky-header"
              field="credit"
              header={() => (
                <div className="">
                  <p>Credit</p>
                </div>
              )}
              body={(rowData) => rowData.credit}
            ></Column>
            {/* <Column
            headerClassName="my-data-table-col sticky-header"
            field="amount"
            header={() => (
              <div className="">
              
                <p>Amount</p>
              </div>
            )}
            body={totalAmountBody}
          ></Column> */}
            <Column
              headerClassName="my-data-table-col sticky-header"
              field="balance"
              header={() => (
                <div className="">
                  <p>Balance</p>
                </div>
              )}
              body={(rowData) => rowData.balance}
            ></Column>
            {/* <Column
            headerClassName=" my-data-table-col"
            field="total_sales"
            header={() => (
              <div className=" ">
                <p className=" fixed -mt-12 text-slate-950">
                  {allCustomerStatementReports?.reduce(
                    (acc, cur) => acc + cur.total_sales,
                    0,
                  )}
                </p>
                <p>Total Cost </p>
              </div>
            )}
            body={totalSalesBody}
          ></Column>
          {values.sales && (
            <Column
              headerClassName=" my-data-table-col"
              field="total_sales"
              header={() => (
                <div className=" ">
                  <p className=" fixed -mt-12 text-slate-950">
                    {allCustomerStatementReports?.reduce(
                      (acc, cur) => acc + cur.total_sales,
                      0,
                    )}
                  </p>
                  <p>Sales </p>
                </div>
              )}
              body={totalSalesBody}
            ></Column>
          )}
          {values.profit && (
            <Column
              headerClassName=" my-data-table-col"
              field="total_amount"
              header={() => (
                <div className=" ">
                  <p className=" fixed -mt-12 text-slate-950">
                    {allCustomerStatementReports?.reduce(
                      (acc, cur) => acc + cur.total_amount,
                      0,
                    )}
                  </p>
                  <p>Profit </p>
                </div>
              )}
              body={totalAmountBody}
            ></Column>
          )}
          {values.profitprcnt && (
            <Column
              headerClassName=" my-data-table-col"
              field="total_amount"
              header={() => (
                <div className=" ">
                  <p className=" fixed -mt-12 text-slate-950">
                    {allCustomerStatementReports?.reduce(
                      (acc, cur) => acc + cur.total_amount,
                      0,
                    )}
                  </p>
                  <p>Profit % </p>
                </div>
              )}
              body={totalAmountBody}
            ></Column>
          )}
          {values.salesReturn && (
            <Column
              headerClassName=" my-data-table-col"
              field="total_amount"
              header={() => (
                <div className=" ">
                  <p className=" fixed -mt-12 text-slate-950">
                    {allCustomerStatementReports?.reduce(
                      (acc, cur) => acc + cur.total_amount,
                      0,
                    )}
                  </p>
                  <p>Sales Return </p>
                </div>
              )}
              body={totalAmountBody}
            ></Column>
          )} */}
          </DataTable>
        </div>
        <style>{css}</style>
      </div>
    </div>
  );
};

export default VendorSalesReportsTable;
